import { render, staticRenderFns } from "./TabelaResultadosAtoInfralegal.vue?vue&type=template&id=1191dce4&scoped=true"
import script from "./TabelaResultadosAtoInfralegal.vue?vue&type=script&lang=js"
export * from "./TabelaResultadosAtoInfralegal.vue?vue&type=script&lang=js"
import style0 from "./TabelaResultadosAtoInfralegal.vue?vue&type=style&index=0&id=1191dce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1191dce4",
  null
  
)

export default component.exports